// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// FOR LOCAL: with emulators
// export const environment = {
//   production: false,
//   useEmulators: true,
//   emulators: {
//     auth: {
//       enabled: false,
//       url: 'http://127.0.0.1:9099'
//     },
//     firestore: {
//       enabled: false,
//       host: '127.0.0.1',
//       port: 8080
//     },
//     functions: {
//       enabled: true,
//       host: '127.0.0.1',
//       port: 5001
//     },
//     storage: {
//       enabled: false,
//       host: '127.0.0.1',
//       port: 9199
//     }
//   },
//   firebase: {
//     projectId: 'bwi-ignite-retail',
//     appId: '1:524058667004:web:eab09635605e427db67479',
//     storageBucket: 'bwi-ignite-retail.appspot.com',
//     apiKey: 'AIzaSyB-vvMiO5I_4VPAtdDrGZED13pMkIj4_rg',
//     authDomain: 'bwi-ignite-retail.firebaseapp.com',
//     messagingSenderId: '524058667004',
//     measurementId: 'G-48Q1KQ77PQ',
//   },
//   typesense: {
//     apiKey: "J1UK8OzlV6x82FX4DwPiEb4idd6D40YM",
//     searchOnlyKey: "8ycbKjn4KHz9lwR9yMf4EEksrYq76Tdj",
//     host: "09vpsuzxlfkribh6p-1.a1.typesense.net",
//     port: 443,
//     protocol: "https"
//   },
//   url: 'https://player.videosity.net/dev-server',
//   achieveWebUrl: "https://achieve-ignite.web.app",
//   impactDashboardUrl: "https://dashboard.velocityps.com.au/admin",
//   posthog: {
//     apiKey: 'phc_uhcf4VWHBZTnJ5pFiAoYuqXOQUoE7tt8QkGt23HSKhD',
//     host: 'https://app.posthog.com'
//   }
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

// FOR LOCAL: without emulators
export const environment = {
  production: false,
  useEmulators: false,
  emulators: {
    auth: {
      enabled: false,
      url: 'http://127.0.0.1:9099'
    },
    firestore: {
      enabled: false,
      host: '127.0.0.1',
      port: 8080
    },
    functions: {
      enabled: false,
      host: '127.0.0.1',
      port: 5001
    },
    storage: {
      enabled: false,
      host: '127.0.0.1',
      port: 9199
    }
  },
  // firebase: {
  //   projectId: 'bwi-1130',
  //   appId: '1:932257713982:web:0a8121349b51a909a3a66f',
  //   storageBucket: 'bwi-1130.appspot.com',
  //   apiKey: 'AIzaSyB5MW-D7g-reJl5c0i1SOwjXWsodYi0Ph4',
  //   authDomain: 'bwi-1130.firebaseapp.com',
  //   messagingSenderId: '932257713982',
  //   measurementId: 'G-QLC24BMMTR',
  // },
  // typesense: {
  //   apiKey: "J1UK8OzlV6x82FX4DwPiEb4idd6D40YM",
  //   searchOnlyKey: "8ycbKjn4KHz9lwR9yMf4EEksrYq76Tdj",
  //   host: "09vpsuzxlfkribh6p-1.a1.typesense.net",
  //   port: 443,
  //   protocol: "https"
  // },
  // url: 'https://player.videosity.net/dev-server',
  // achieveWebUrl: "https://achieve-ignite.web.app",
  // impactDashboardUrl: "https://dashboard.velocityps.com.au/admin",
  // posthog: {
  //   apiKey: 'phc_uhcf4VWHBZTnJ5pFiAoYuqXOQUoE7tt8QkGt23HSKhD',
  //   host: 'https://app.posthog.com'
  // }
    firebase: {
    projectId: 'bwi-ignite-retail',
    appId: '1:524058667004:web:eab09635605e427db67479',
    storageBucket: 'bwi-ignite-retail.appspot.com',
    apiKey: 'AIzaSyB-vvMiO5I_4VPAtdDrGZED13pMkIj4_rg',
    authDomain: 'bwi-ignite-retail.firebaseapp.com',
    messagingSenderId: '524058667004',
    measurementId: 'G-48Q1KQ77PQ',
  },
  typesense: {
    apiKey: "J1UK8OzlV6x82FX4DwPiEb4idd6D40YM",
    searchOnlyKey: "8ycbKjn4KHz9lwR9yMf4EEksrYq76Tdj",
    host: "09vpsuzxlfkribh6p-1.a1.typesense.net",
    port: 443,
    protocol: "https"
  },
  url: 'https://player.videosity.net/dev-server',
  achieveWebUrl: "https://achieve-ignite.web.app",
  impactDashboardUrl: "https://dashboard.velocityps.com.au/admin",
  posthog: {
    apiKey: 'phc_uhcf4VWHBZTnJ5pFiAoYuqXOQUoE7tt8QkGt23HSKhD',
    host: 'https://app.posthog.com'
  }
};

